export default __webpack_public_path__ + "static/media/001.24b1d1cf.png";